module.exports = __webpack_public_path__ + "r-v3/img/ml_25_00.bdad7f64.jpg";